import React, { useState, useEffect } from 'react';
import { Card, Typography, Descriptions, Avatar, Button, Divider, Tag } from 'antd';
import { UserOutlined, MailOutlined, CalendarOutlined, EditOutlined } from '@ant-design/icons';
import { Link } from 'react-router-dom';
import './index.css';

const { Title, Text } = Typography;

const MyProfile = () => {
  // 模拟用户信息数据
  const [userInfo, setUserInfo] = useState({
    name: '张三',
    email: 'zhangsan@example.com',
    bio: '热爱写作的开发者，专注于技术分享和经验总结。',
    joinDate: '2023年1月',
    postsCount: 24,
    avatar: 'https://via.placeholder.com/150'
  });

  // 模拟获取用户信息
  useEffect(() => {
    // 这里可以加入实际获取用户信息的API调用
    console.log('加载用户信息');
  }, []);

  return (
    <div className="my-profile-page">
      <Card 
        style={{ maxWidth: 800, margin: '0 auto', marginBottom: 24 }}
        cover={
          <div style={{ 
            height: 150, 
            backgroundColor: '#f0f2f5', 
            display: 'flex', 
            alignItems: 'flex-end', 
            justifyContent: 'center' 
          }}>
            <Avatar 
              size={100} 
              icon={<UserOutlined />} 
              src={userInfo.avatar} 
              style={{ marginTop: 60, border: '4px solid white' }} 
            />
          </div>
        }
      >
        <div style={{ textAlign: 'center', marginBottom: 24 }}>
          <Title level={2}>{userInfo.name}</Title>
          <div style={{ marginTop: 16 }}>
            <Tag color="blue">博主</Tag>
            <Tag color="green">技术爱好者</Tag>
            <Tag color="orange">分享者</Tag>
          </div>
        </div>

        <Descriptions 
          bordered 
          column={1} 
          style={{ marginBottom: 24 }}
          labelStyle={{ width: '100px', fontWeight: 'bold' }}
        >
          <Descriptions.Item label="邮箱">
            <MailOutlined /> {userInfo.email}
          </Descriptions.Item>
          <Descriptions.Item label="加入时间">
            <CalendarOutlined /> {userInfo.joinDate}
          </Descriptions.Item>
          <Descriptions.Item label="文章数">
            {userInfo.postsCount}
          </Descriptions.Item>
        </Descriptions>

        <div style={{ marginBottom: 24 }}>
          <h3>个人简介</h3>
          <Text type="secondary">{userInfo.bio}</Text>
        </div>

        <Divider />

        <div style={{ textAlign: 'center' }}>
          <Button type="primary" icon={<EditOutlined />}>
            编辑个人信息
          </Button>
        </div>
      </Card>

      <Card title="最近文章" style={{ maxWidth: 800, margin: '0 auto' }}>
        <div style={{ textAlign: 'center', padding: '40px 0' }}>
          <Text type="secondary">暂无文章数据</Text>
          <div style={{ marginTop: 16 }}>
            <Button type="primary">
              <Link to="/write-post">写第一篇文章</Link>
            </Button>
          </div>
        </div>
      </Card>
    </div>
  );
};

// 为了保持路由兼容，仍然导出为Auth组件
export default MyProfile;